// extracted by mini-css-extract-plugin
export var chevronIcon = "_86-2";
export var teamName = "_86-1";
export var teamSwitcherButton = "_86-0";